module.exports = __webpack_public_path__ + "static/media/higsystem-full-logo.498c7908.svg";